import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Star, ChevronLeft, ChevronRight, X } from "lucide-react";

const REVIEWS = [
    { name: "Fernando Cañizares", date: "Hace un año", text: "Me atendió Santiago y solo tengo buenas palabras. No solo por haber conseguido la mejor hipoteca para mis condiciones, sino porque el trato humano, la profesionalidad y la cercanía con la que me ha acompañado en un proceso que era desconocido para mi, han sido inmejorables. Totalmente recomendable!" },
    { name: "Guillermo Cañero", date: "Hace un año", text: "Inicié un proceso de análisis de hipotecas y la ayuda de Santiago Ferrer fue imprescindible. No sólo me dio alternativas competentes con distintos bancos, sino que dedicó un gran tiempo a explicarme conceptos bancarios y económicos que me ayudaron a tomar mejor la decisión. Sin duda, el soporte y seguimiento de Santiago, recomendables al 100%.", avatar: "/assets/avatars/rev-01.png" },
    { name: "Maria Flaquer", date: "Hace un año", text: "Contacté a Keypoteca por recomendación de un familiar y mo puedo estar más satisfecha. Santiago no sólo me consiguió una muy buena hipoteca, sino que también me explicó con paciencia todo lo que debía entender sobre hipotecas. Lo recomiendo 100%. Gracias Santiago!", avatar: "/assets/avatars/rev-02.png" },
    { name: "Manuel Ruiz", date: "Hace un año", text: "Me atendieron súper bien desde el primer momento. A los tres días ya tenia ofertas de otros bancos para cambiar mi hipoteca muy buenas. La atención y seguimiento de la operación por parte de Santiago fue de diez. Lo recomiendo a él y a la plataforma. Diez sobre diez." },
    { name: "Manuel Jesús Bueno", date: "Hace 2 años", text: "Me han ayudado y asesorado en el cambio de mi hipoteca variable a fijo de una forma inmejorable. Grandes profesionales con fuerte conocimiento en el sector y con gran capacidad para transmitirlo. En mi caso agradecido con Santiago por su gran gestión y experiencia. Recomendable acudir a Keypoteca.", avatar: "/assets/avatars/rev-04.png" },
    { name: "Yander Nápoles", date: "Hace 4 años", text: "He utilizado los servicios de Keypoteca ya en dos ocasiones, a principios de 2019(creo que fui uno de sus primeros clientes), y luego a principios de este año. En ambas ocasiones he conseguido las mejores condiciones hipotecarias del momento, y he tenido la seguridad de no dar ni un paso en falso. Ha sido una tremenda suerte contar con ellos, y especialmente con Santiago, que es un gran profesional y mejor persona. ¡Gracias!", avatar: "/assets/avatars/rev-05.png" },
    { name: "Marc Gasull", date: "Hace 2 años", text: "He contratado una nueva hipoteca a traves de los servicios de Keypoteca y ha sido muy buena experiencia. Mi gestor Santi es muy buen profesional y ha hecho un trabajo extraordinario. Ha mostrado un gran conocimiento de todo el proceso de contratación y me ha dado soporte en todos los pasos del proceso. Recomiendo Keypoteca 100%." },
    { name: "Joan", date: "Hace 2 años", text: "Muy contento con el servicio. Es gratuito y están muy pendientes de lo que necesitas. Les pasas toda la documentación y ellos la mueven entre todos los bancos, buscando la mejor hipoteca de entre todos. El asesor que me tocó, Santiago F., ha sido siempre muy amable y atento. Si buscáis hipoteca lo recomiendo frente a la pereza de ir banco por banco preguntando.", avatar: "/assets/avatars/rev-07.png" },
    { name: "Raquel Delgado Alonso", date: "Hace 2 años", text: "Un servicio de 10! Queremos agradecer al equipo de Keypoteca y sobre todo a Santiago Ferrer el trabajo que han hecho gestionando nuestra hipoteca. Hemos conseguido unas condiciones super buenas y han estado pendientes explicando cualquier duda a cualquier hora del día. Gracias os recomendaremos a cualquiera que vaya a contratar una hipoteca, seguro!!!" },
    { name: "xbryan Fury", date: "Hace 2 años", text: "Keypoteca me ha ayudado mucho en el proceso de elegir la hipoteca. El gestor asignado (Santiago), ha estado en contacto permanente conmigo informándome sobre el estado y ha estado también en contacto con los distintos bancos para mejorar las condiciones. Me han resuelto varías dudas y también se encargaron de gestionar la tasación de la vivienda." },
    { name: "Vanesa peinado herreros", date: "Hace 4 años", text: "Contactamos con Keypoteca para la contratación de un préstamo hipotecario y tuvimos la suerte de que nos asignaran a Santiago como asesor personal, que nos ha ayudado en todo momento, buscándonos las mejores condiciones, y siempre disponible para resolver todas las dudas que teníamos (que han sido bastantes). Ha sido un placer trabajar con un gran profesional tan cercano y humano Mil gracias por tu paciencia y por poner tú conocimiento a nuestra disposición, que ha contribuido a hacer más fácil nuestro periplo hipotecario" },
    { name: "David Merino", date: "Hace 3 años", text: "Muy contento y agradecido con Keypoteca. El proceso es muy sencillo e intuitivo, y la experiencia ha sido muy buena. Mención especial a Santiago, que nos brindó un servicio excepcional: ofreciéndonos diferentes opciones que se adaptaban a nuestro escenario concreto y consiguiéndonos las mejores condiciones, siempre con una magnífica actitud.", avatar: "/assets/avatars/rev-11.png" },
    { name: "Raúl Mansilla", date: "Hace 3 años", text: "Nuestra experiencia ha sido muy positiva; nos asesoraron y nos consiguieron una muy buena propuesta para un préstamo hipotecario. Estamos muy contentos con el servicio recibido, y la comunicación con nuestro gestor (Santiago) siempre ha sido buena, clara y fluida. Lo recomendaria sin dudarlo, no sólo por el estudio previo si no por el seguimiento y gestión que hacen personalizado a cada perfil." },
    { name: "Wayne Nicholls", date: "Hace 3 años", text: "Estoy muy satisfecho con el servicio brindado por Keypoteca. Santiago ha sido de gran ayuda durante todo el proceso y pudo obtener una oferta muy interesante cuando otros proveedores no pudieron. Recomendaría encarecidamente a Santiago para futuros emprendimientos hipotecarios.", avatar: "/assets/avatars/rev-13.png" },
    { name: "Esteban Sierra Roldán", date: "Hace 2 años", text: "El trato y el servicio han sido fantásticos. Rapidez en los trámites y la comunicación. Santiago ha sido mi asesor asignado y me ha ayudado con las dudas que tenía y me ha informado muy bien de todo lo necesario para llevar a cabo la operación bancaria. Recomendable 100%", avatar: "/assets/avatars/rev-14.png" },
    { name: "José Carlos Agrela", date: "Hace 3 años", text: "Excelente servicio el que he recibido. Muy buena atención al cliente, con un seguimiento muy personalizado y constante, como en los objetivos conseguidos. Dudo que hubiera alcanzado estas ofertas de los diferentes bancos consultados si hubiera actuado solo o con otra empresa de la competencia (a las que también consulté).. Absolutamente recomendable. Especial mención a Santiago Ferrer, buen trabajo", avatar: "/assets/avatars/rev-15.png" },
    { name: "Manuel Perez-Tabernero", date: "Hace 2 años", text: "Una gran ayuda de un gran equipo de profesionales, buscaron la mejor oferta para mis necesidades e incluso negociaron para mejorarla. Muy contento con Santiago especialmente que se involucró desde el principio y además me ayudó con el papeleo." },
    { name: "Diego Escobar", date: "Hace 4 años", text: "Mi experiencia con Keypoteca y con Santi ha sido brillante, desde el primer momento me han dado confianza y toda la ayuda posible para encontrar la mejor hipoteca. También, durante todo el proceso, ha estado atento y me ha resuelto cualquier duda. Sin duda, lo más recomendable para cualquier persona que necesite encontrar una hipoteca para su casa.", avatar: "/assets/avatars/rev-17.png" },
    { name: "Adrián Beloki", date: "Hace 2 años", text: "Fantástico servicio de gestión de hipotecas. Santiago nos echó una mano en todo el proceso, incluso después de un imprevisto gordo con el primer banco con el que quisimos cerrar el acuerdo. Atentos, gratuitos y muy pragmáticos.", avatar: "/assets/avatars/rev-18.png" },
    { name: "Gustavo Recio", date: "Hace 3 años", text: "Genial mi experiencia con Keypoteca. Antes de utilizarlo había visitado varias entidades bancarias para tantear las condiciones. Con unos pocos clicks en Keypoteca me llegaron ofertas en entidades que ni se me había ocurrido buscar, y con mejores condiciones que yo había conseguido en persona. Una vez iniciado el proceso tanto Santiago como Yolanda me acompañaron en todo momento para aclarar dudas, y acelerar la operación. Si estás buscando financiación recomiendo totalmente tantear las condiciones que podrías conseguir con Keypoteca." },
    { name: "carmelo Rangel", date: "Hace 3 años", text: "Santiago ha sido mi asesor y en todo momento estubo muy atento, luchó mucho las mejores condiciones y agilizó mucho el proceso. En general estoy muy contento con su trabajo de el y de Keypoteca en general.", avatar: "/assets/avatars/rev-20.png" },
    { name: "Fernando Fauste", date: "Hace 2 años", text: "Muy contento con el servicio. La verdad es que me facilitaron varias opciones y muy competitivas todas ellas. La atención prestada por Santiago, el asesor, fue excepcional, siempre encima de la operación y abierto a resolver cualquier duda o problema.", avatar: "/assets/avatars/rev-21.png" },
    { name: "Joan Grande", date: "Hace un año", text: "Me atendió Santiago Ferrer y la verdad es que me consiguió la subrogación que justo necesitaba. Ha realizado un seguimiento exhaustivo de mi caso y me ha realizado varias llamadas de seguimiento por si necesitaba su ayuda.", avatar: "/assets/avatars/rev-22.png" },
    { name: "Yabel CC", date: "Hace 2 años", text: "Súper recomendado, nos ayudaron a conseguir la hipoteca en un tiempo récord dado que teníamos una urgencia. Santiago llevo nuestro caso día a día y estuvo al pendiente en todo momento." },
    { name: "FRANCISCO Fng", date: "Hace un año", text: "Excelentes profesionales. Especialmente agradecido con la gestión llevada a cabo con Santiago Ferrer, que ha sido de gran ayuda para tomar la decisión final." },
    { name: "J GD", date: "Hace 2 años", text: "Todo ha ido genial con la empresa. Santi ha sido un asesor y gestor que ha estado siempre pendiente y explicándonos todas las dudas y buscándonos las mejores condiciones en todo momento. 100% recomendable! Preguntad por Santi!" },
    { name: "Javi Todocamino", date: "Hace 2 años", text: "Si quieres cambiar de hipoteca, te buscan las mejores soluciones en entidades financieras, en nuestro caso, Santiago, nos acompaño en todo momento de principio a firma de hipoteca, siempre atento, y agilizando con el banco todo el papeleo, totalmente recomendado." },
    { name: "Jose Luis Sixto", date: "Hace 3 años", text: "La profesionalidad, honestidad y escucha de Santiago Ferrer estudiando nuestro caso nos ha ayudado enormemente en la toma de decisiones para nuestra hipoteca. Le estamos muy agradecidos", avatar: "/assets/avatars/rev-27.png" },
    { name: "Dani Casta", date: "Hace 3 años", text: "El servicio que me han dado no ha podido ser mejor, nunca me imagine que nos pudieran ayudar tanto. En nuestro caso nos llevo la operación Santiago y nos consiguieron la mejor oferta del mercado sin ninguna vinculación." },
    { name: "alfonso martinez", date: "Hace 2 años", text: "Santiago me consiguió una hipoteca con mejores condiciones que llamando yo directamente a los bancos, hizo un seguimiento cada pocos días para asegurar que se cerrase la operación" },
    { name: "Ivan Maguregui", date: "Hace 3 años", text: "Muy contento con el servicio prestado. Santiago ha sido un gran profesional. Muy recomendable para una toma de decisión tan importante." },
    { name: "A Leka", date: "Hace 3 años", text: "Venía buscando una financiación del 90% (ya que del 100% es imposible) y ninguna entidad lo ofrecía, aún teniendo una condición económica estable. En Keypoteca, con el equipo de Santi la conseguimos, bastante antes de lo que esperaba!", avatar: "/assets/avatars/rev-31.png" },
    { name: "Carlos Ck", date: "Hace 2 años", text: "Muy agradecido a Santiago, muy atento y muy implicado, sin duda lo recomiendo para la búsqueda de hipotecas. as gracias por la paciencia y el trabajo." },
];

const AVATAR_COLORS = [
    "bg-emerald-600",
    "bg-[#2E5480]",
    "bg-amber-600",
    "bg-rose-600",
    "bg-sky-700",
    "bg-violet-600",
    "bg-teal-600",
    "bg-orange-700",
];

function Stars({ size = 14 }) {
    return (
        <div className="flex gap-0.5" aria-label="5 estrellas">
            {[...Array(5)].map((_, s) => (
                <Star
                    key={s}
                    size={size}
                    className="text-amber-400"
                    fill="currentColor"
                    strokeWidth={0}
                />
            ))}
        </div>
    );
}

function Avatar({ review, index, size = "w-11 h-11", textSize = "text-lg" }) {
    if (review.avatar) {
        return (
            <img
                src={review.avatar}
                alt={`Foto de ${review.name}`}
                loading="lazy"
                className={`${size} rounded-full object-cover shrink-0`}
            />
        );
    }
    const initial = review.name.trim().charAt(0).toUpperCase();
    const color = AVATAR_COLORS[index % AVATAR_COLORS.length];
    return (
        <span
            className={`flex items-center justify-center ${size} rounded-full text-white font-display font-bold ${textSize} ${color} shrink-0`}
            aria-hidden="true"
        >
            {initial}
        </span>
    );
}

function ReviewCard({ review, index, onOpen }) {
    return (
        <figure
            data-testid={`review-card-${index}`}
            onClick={() => onOpen(review, index)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && onOpen(review, index)}
            className="w-[320px] sm:w-[360px] shrink-0 rounded-3xl border border-slate-200/80 bg-white p-6 shadow-sm transition-[box-shadow,transform,border-color] duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-slate-200/70 hover:border-emerald-300/60 flex flex-col cursor-pointer snap-start"
        >
            <div className="flex items-center gap-3">
                <Avatar review={review} index={index} />
                <span className="min-w-0">
                    <span className="block font-semibold text-[#0F172A] text-sm truncate">
                        {review.name}
                    </span>
                    <span className="block text-xs text-slate-400">
                        {review.date}
                    </span>
                </span>
            </div>
            <div className="mt-3">
                <Stars />
            </div>
            <blockquote className="mt-3 text-[14px] text-slate-600 leading-relaxed line-clamp-5">
                {review.text}
            </blockquote>
            <span className="mt-3 text-[13px] font-semibold text-emerald-600">
                Leer reseña completa
            </span>
        </figure>
    );
}

function ReviewModal({ review, index, onClose }) {
    useEffect(() => {
        const onKey = (e) => e.key === "Escape" && onClose();
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [onClose]);

    return (
        <motion.div
            data-testid="review-modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={onClose}
            className="fixed inset-0 z-[70] flex items-center justify-center bg-[#0B1A2B]/70 backdrop-blur-sm px-4"
        >
            <motion.div
                initial={{ opacity: 0, y: 32, scale: 0.96 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: 20, scale: 0.97 }}
                transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                onClick={(e) => e.stopPropagation()}
                data-lenis-prevent
                className="relative w-full max-w-xl max-h-[85vh] overflow-y-auto no-scrollbar rounded-3xl bg-white p-8 shadow-2xl"
            >
                <button
                    data-testid="review-modal-close"
                    onClick={onClose}
                    aria-label="Cerrar reseña"
                    className="absolute top-5 right-5 flex items-center justify-center w-9 h-9 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-600 transition-colors"
                >
                    <X size={17} />
                </button>
                <div className="flex items-center gap-4">
                    <Avatar
                        review={review}
                        index={index}
                        size="w-14 h-14"
                        textSize="text-2xl"
                    />
                    <span>
                        <span className="block font-display font-bold text-[#0F172A] text-lg">
                            {review.name}
                        </span>
                        <span className="block text-sm text-slate-400">
                            {review.date}
                        </span>
                    </span>
                </div>
                <div className="mt-4">
                    <Stars size={16} />
                </div>
                <blockquote
                    data-testid="review-modal-text"
                    className="mt-4 text-[15px] text-slate-700 leading-relaxed whitespace-pre-line"
                >
                    {review.text}
                </blockquote>
            </motion.div>
        </motion.div>
    );
}

function PanZone({ side, rowRef }) {
    const raf = useRef(null);
    const dir = side === "left" ? -1 : 1;

    const start = () => {
        const step = () => {
            rowRef.current?.scrollBy({ left: dir * 3 });
            raf.current = requestAnimationFrame(step);
        };
        raf.current = requestAnimationFrame(step);
    };
    const stop = () => cancelAnimationFrame(raf.current);
    const jump = () =>
        rowRef.current?.scrollBy({ left: dir * 420, behavior: "smooth" });

    return (
        <button
            data-testid={`reviews-pan-${side}`}
            aria-label={side === "left" ? "Ver anteriores" : "Ver siguientes"}
            onMouseEnter={start}
            onMouseLeave={stop}
            onClick={jump}
            className={`hidden md:flex absolute top-0 bottom-4 ${
                side === "left" ? "left-0" : "right-0"
            } w-20 lg:w-28 items-center justify-center z-10 opacity-0 hover:opacity-100 transition-opacity duration-300 ${
                side === "left"
                    ? "bg-gradient-to-r from-white via-white/80 to-transparent"
                    : "bg-gradient-to-l from-white via-white/80 to-transparent"
            }`}
        >
            <span className="flex items-center justify-center w-11 h-11 rounded-full bg-[#1F3B5B] text-white shadow-lg">
                {side === "left" ? (
                    <ChevronLeft size={20} />
                ) : (
                    <ChevronRight size={20} />
                )}
            </span>
        </button>
    );
}

export default function Testimonials() {
    const rowRef = useRef(null);
    const [selected, setSelected] = useState(null);

    return (
        <section
            id="opiniones"
            data-testid="testimonials-section"
            className="bg-white py-20 lg:py-28 overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 32 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.6 }}
                    className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6"
                >
                    <div className="max-w-xl">
                        <p className="font-mono text-xs uppercase tracking-[0.25em] text-emerald-600">
                            Opiniones
                        </p>
                        <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#0F172A]">
                            ¿Qué dicen nuestros clientes?
                        </h2>
                    </div>
                    <div
                        data-testid="rating-summary"
                        className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-[#F5F7FA] px-6 py-4"
                    >
                        <span className="font-display text-4xl font-extrabold text-[#1F3B5B]">
                            5,0
                        </span>
                        <span>
                            <Stars />
                            <span className="block text-xs text-slate-500 mt-1">
                                {REVIEWS.length} valoraciones de clientes
                            </span>
                        </span>
                    </div>
                </motion.div>
            </div>

            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: 0.15 }}
                className="relative mt-14"
            >
                <PanZone side="left" rowRef={rowRef} />
                <PanZone side="right" rowRef={rowRef} />
                <div
                    ref={rowRef}
                    data-testid="reviews-scroll-row"
                    data-lenis-prevent
                    className="flex gap-6 overflow-x-auto no-scrollbar px-4 sm:px-6 lg:px-8 pb-4 snap-x"
                >
                    {REVIEWS.map((r, i) => (
                        <ReviewCard
                            key={r.name}
                            review={r}
                            index={i}
                            onOpen={(review, index) =>
                                setSelected({ review, index })
                            }
                        />
                    ))}
                </div>
            </motion.div>

            <AnimatePresence>
                {selected && (
                    <ReviewModal
                        review={selected.review}
                        index={selected.index}
                        onClose={() => setSelected(null)}
                    />
                )}
            </AnimatePresence>
        </section>
    );
}
